import Error from "./Error";
import { useEffect, useState } from "react"
import API from "../../../services/API/Study"
import Loader from "../../Tools/Loader";

export default function View({enrollment, view}){

    const [url, setUrl] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {

        API.getView(enrollment?.id, view)
            .then(r => {
                let blob = new Blob([r.data], {type: "text/html"});
                let url = window.URL.createObjectURL(blob);
                return setUrl( url )
            })
            .catch(e => setError(true))

        return () => {
            setUrl(null)
            setError(false)
        }

    }, [enrollment, view])


    return error ? <Error/> :
    (
        url ? 
            <iframe
                id={view}
                title={view}
                src={url} 
                width="100%"
                height="99%"
                frameBorder="0"
                allow="autoplay; fullscreen"
            >
            </iframe>
            : 
            <Loader />
    )

}
